export default {
  title: "Regra tipo 1 - Alocação máxima de um colaborador em um projeto",
  subtitle: "Qual o percentual máximo do salário de todos os colaboradores em um determinado projeto? Cada projeto pagará no máximo esse percentual.",
  token: "collab_max_allocation_in_proj",
  orderBy: "value_b",
  paramsVerify: {
    param: "value_b",
    value: "*",
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit",
      columns: [
        {
          label: "Centro de custo",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome do CC",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
        {
          label: "Alocação máxima",
          key: "value_c",
          type: "percent",
        },
      ],
      data: [],
    },
    {
      type: "exception",
      title: "Exceções",
      actions: "edit_remove",
      columns: [
        {
          label: "Centro de custo",
          key: "value_b",
        },
        {
          label: "Nome do CC",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
        {
          label: "Alocação máxima",
          key: "value_c",
          type: "percent",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Alocação máxima de um colaborador em um projeto",
    form: [
      {
        label: "Informe o Centro de Custo:",
        type: "list",
        info: "Acrescente * para selecionar todos",
        key: "value_b",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe a alocação máxima do Centro de Custo:",
        type: "percent",
        key: "value_c",
        value: "",
        visible: true,
      },
    ],
  },
};
